import * as React from "react";

import { IRecurrence } from "../../classes/recurrencePattern";
import { IText } from "../../classes/text";
import { IText_AddEditEvent } from "../../classes/text_AddEditEvent";

import { LoadingSpinner } from "../../../Common/LoadingSpinner/LoadingSpinner";
import { RecurrencePatternEditor } from "./RecurrencePatternEditor";

export interface IRecurrenceModalLoadingAndCloseButton {
	addEditText: IText_AddEditEvent;
	currentStartDate: Date;
	dateOfFirstEventInRecurrence: Date;
	firstDayOfWeek: string;
	isLoading: boolean;
	isFromTwoWayCalendar: boolean;
	isTwoWayCalendarEvent: boolean;
	onCloseModal: () => void;
	onUpdateRecurrence: (recurrence: IRecurrence, dateOfFirstEventInRecurrence: Date, firstDayOfWeek: string) => void;
	text: IText;
	recurrencePattern: IRecurrence;
	userDateFormat: string;
}

export const RecurrenceModalLoadingAndCloseButton: React.SFC<IRecurrenceModalLoadingAndCloseButton> = (props) => {

	// Use a useRef hook to create a reference, which is set to point to the anchor (see below).
	const closeButtonRef = React.useRef(null);

	// Using an useEffect hook to replace the componentDidMount lifecycle method that used to exist when this was a stateful React class component.
	React.useEffect(() => {
		closeButtonRef.current.focus(); // Initial focus should be put on the 'X' at the top right when the modal opens.
	});

	const txtLoadingEvents = props.text.eventViews.loadingEvents;
	const txtClose = props.text.selectEvents.close;

	const onClickCloseModalButton = (event: any) => {
		event.preventDefault();
		props.onCloseModal();
	};

	return (
		<>
			<div className="CAL_modalHeader">
				<a href="#" onClick={onClickCloseModalButton} className="CMS_dialogClose CMS_button CMS_bSquare CMS_bCancel" ref={closeButtonRef}><em className="fa fa-times" aria-hidden="true"></em><span className="offScreen">{txtClose}</span></a>
			</div>

			<div className="CAL_modalContent CMS_minimumHeight">

				{props.isLoading &&
					<LoadingSpinner showSpinner={true} loadingText={txtLoadingEvents} />
				}

				{!props.isLoading &&
					<RecurrencePatternEditor
						addEditText={props.addEditText}
						currentStartDate={props.currentStartDate}
						dateOfFirstEventInRecurrence={props.dateOfFirstEventInRecurrence}
						firstDayOfWeek={props.firstDayOfWeek}
						isFromTwoWayCalendar={props.isFromTwoWayCalendar}
						isTwoWayCalendarEvent={props.isTwoWayCalendarEvent}
						onCloseModal={props.onCloseModal}
						onUpdateRecurrence={props.onUpdateRecurrence}
						text={props.text}
						recurrencePattern={props.recurrencePattern}
						userDateFormat={props.userDateFormat}
					/>
				}

			</div>
		</>
	);
};
